import {Component, OnInit} from '@angular/core';
import {NavigationService} from '../../../shared/services/navigation.service';
import {PodSearchMode, PodState} from '../../../pods-validation/shared/pod-validation.model';
import {PodValidationWidgetCarrierManagerData} from '../shared/pod-validation-widget-carrier-manager-data.model';
import {WidgetsService} from '../shared/widgets.service';

@Component({
  selector: 'app-widget-pod-carrier-manager',
  templateUrl: './widget-pod-carrier-manager.component.html',
  styleUrls: ['./widget-pod-carrier-manager.component.scss']
})
export class WidgetPodCarrierManagerComponent implements OnInit {

  data = new PodValidationWidgetCarrierManagerData();
  PodSearchMode = PodSearchMode;
  PodState = PodState;

  refresh = false;

  constructor(
    private navigationService: NavigationService,
    private widgetsService: WidgetsService
  ) { }

  ngOnInit(): void {
    this.getWidgetData(false);
  }

  getWidgetData(forceRefresh: boolean) {
    this.widgetsService.getPodValidationCarrierManagerWidgetData(forceRefresh)
      .subscribe(data => {
        this.data = data;
      });
  }

  refreshData() {
    if (this.refresh === false) {
      this.refresh = true;
      this.getWidgetData(true);
      setTimeout(() => this.refresh = false, 1000);
    }
  }

  goToPodValidation(mode: PodSearchMode, state: PodState) {
    this.navigationService.podsValidation()
      .overall(mode, state)
      .go()
  }
}
